import { PointFeature } from '../../types';

import { styles } from './PickupMarker.styles';

interface PickupMarkerProps {
  feature: PointFeature;
  onClick: (feature: PointFeature) => void;
  isSelected: boolean;
}

export function PickupMarker({
  feature,
  onClick,
  isSelected
}: PickupMarkerProps) {
  const slots = styles({ isSelected });

  const handleClick = () => {
    onClick(feature);
  };

  return (
    <button
      className={slots.marker()}
      onClick={handleClick}
    >
      <span className={slots.markerInner()} />
    </button>
  );
}
